import { Box } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'src/components/Loader';
import NotFound from 'src/views/components/NotFound';
import { useProductPassport, useProductPassportImpacts } from '../hooks';
import ProductPassportRenderer from './Renderer';
import {
  getResolvedPassportBlocks,
  getResolvedPassportBranding,
} from './config';
import { getPassportUrl } from './utils';

export default function ProductPassport() {
  const { passportToken } = useParams();
  const { product: passportProduct, isLoading } = useProductPassport(
    passportToken as string
  );
  const { impacts, isLoading: areImpactsLoading } = useProductPassportImpacts(
    passportToken as string,
    !!passportProduct
  );
  const product = React.useMemo(
    () =>
      passportProduct
        ? { ...passportProduct, impacts: impacts || passportProduct.impacts }
        : undefined,
    [impacts, passportProduct]
  );

  if (isLoading) {
    return <Loader />;
  }

  if (!product || !passportToken) {
    return <NotFound />;
  }

  return (
    <Box sx={{ ml: { xs: 2, md: '48px' }, mr: { xs: 2, md: '48px' }, mb: 6 }}>
      <ProductPassportRenderer
        product={product}
        blocks={getResolvedPassportBlocks(passportToken)}
        branding={getResolvedPassportBranding(passportToken)}
        passportUrl={getPassportUrl(passportToken)}
        impactsLoading={areImpactsLoading}
        showPageTitle
      />
    </Box>
  );
}
